import type { CompareProduct } from '../types';

export function renderStickyHeader(products: CompareProduct[], maxCompare = 3): string {
  return `
    <div class="flex flex-nowrap gap-2x m:gap-6x px-4x m:px-2x py-4x items-start">
      ${products
        .map((product) => {
          const variants = product.variants || [];

          const activeVariantId = product.currentVariantId || (variants.length > 0 ? variants[0].id : '');

          const currentVariant = variants.find((variant) => variant.id.toString() === activeVariantId.toString());

          const price = currentVariant ? currentVariant.price : product.price;

          const comparePrice = currentVariant?.compare_at_price;

          const hasDiscount = comparePrice && comparePrice !== price;

          return `
            <div
              class="relative w-[144px] m:w-[200px] shrink-0 flex-1 p-2x"
              data-sticky-id="${product.id}"
            >
              <div class="compare-chip-spacer mb-2x hidden min-h-[24px]"></div>

              <div
                class="compare-match-chip text-center w-full hidden mb-2x"
                data-product-chip="${product.id}"
              ></div>

              <div class="label-s line-clamp-1">
                ${product.title}
              </div>

              <p class="body-s line-clamp-1">
                ${product.features ? product.features.join(' / ') : ''}
              </p>

              ${
                hasDiscount
                  ? `
                    <div class="flex items-center gap-1x sticky-price pt-2x">
                      <span class="badge-discount px-1x rounded-sm">
                        <span class="heading-xs">
                          ${price}
                        </span>
                      </span>

                      <span class="body-s line-through text-content-secondary">
                        ${comparePrice}
                      </span>
                    </div>
                  `
                  : `
                    <div class="heading-xs sticky-price pt-2x">
                      ${price}
                    </div>
                  `
              }
            </div>
          `;
        })
        .join('')}

      ${Array.from({ length: maxCompare - products.length })
        .map(
          (_, index) => `
            <div class="w-[144px] m:w-[200px] flex-1 shrink-0 px-2x">
              <div class="compare-chip-spacer mb-2x hidden min-h-[24px]"></div>
              <div class="compare-placeholder flex flex-1 basis-0 flex-col w-full py-5x m:py-0 items-center border-xs border-dashed border-tertiary rounded-m h-[62px] m:h-[80px] justify-center label-s text-content-tertiary bg-primary">
                ${products.length + index + 1}/${maxCompare}
              </div>
            </div>
          `,
        )
        .join('')}
    </div>
  `;
}
